import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Shield, Eye, AlertTriangle, CreditCard } from 'lucide-react';

export default function LegalDocuments() {
  const policies = [
    {
      id: 'privacy',
      title: 'Privacy Policy',
      description: 'Hoe wij uw persoonlijke gegevens verzamelen, gebruiken en beschermen',
      icon: Shield,
      route: '/legal/privacy-policy'
    },
    {
      id: 'terms-of-service',
      title: 'Terms of Service',
      description: 'Algemene voorwaarden en gebruiksvoorwaarden van StudyStay',
      icon: FileText,
      route: '/legal/terms-of-service'
    },
    {
      id: 'cookie',
      title: 'Cookie Policy',
      description: 'Informatie over hoe wij cookies gebruiken op onze website',
      icon: Eye,
      route: '/legal/cookie-policy'
    },
    {
      id: 'platform-liability',
      title: 'Platform Liability Policy',
      description: 'Aansprakelijkheid en verantwoordelijkheid van platform en gebruikers',
      icon: AlertTriangle,
      route: '/legal/platform-liability-policy'
    },
    {
      id: 'subscription',
      title: 'Subscription Policy',
      description: 'Abonnementen, betalingen en opzegvoorwaarden',
      icon: CreditCard,
      route: '/legal/subscription-policy'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="container-professional py-12">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8">
            <Link
              to="/welcome"
              className="inline-flex items-center space-x-2 text-gray-600 hover:text-ios-blue mb-6 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Terug naar home</span>
            </Link>

            <div className="bg-gradient-to-r from-ios-blue to-blue-600 rounded-2xl shadow-lg p-8 text-white">
              <div className="flex items-center space-x-4 mb-4">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                  <FileText className="w-8 h-8" />
                </div>
                <div>
                  <h1 className="text-4xl font-bold mb-2">Juridische Documenten</h1>
                  <p className="text-blue-100">Alle policies en voorwaarden als live PDF</p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {policies.map((policy) => {
              const Icon = policy.icon;
              return (
                <Link
                  key={policy.id}
                  to={policy.route}
                  className="bg-white rounded-xl shadow-md border-2 border-gray-200 p-6 hover:border-blue-500 hover:shadow-lg transition-all duration-300 group"
                >
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-600 transition-colors">
                      <Icon className="w-6 h-6 text-blue-600 group-hover:text-white transition-colors" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                        {policy.title}
                      </h3>
                      <p className="text-sm text-gray-600 line-clamp-2">
                        {policy.description}
                      </p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
